
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft8 as ObiWindShaft8Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-8.js';
 
 
 

 
 export const ObiWindShaft8 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-8',
   elementClass: ObiWindShaft8Element,
   events: {
     
   }
  });
 
 